import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
import { createPopper } from '@popperjs/core';
import { useRef, useMemo, useLayoutEffect } from 'react';
export default (function () {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var referenceRef = useRef();
  var popperRef = useRef();
  var instanceRef = useRef();
  var combinedOptions = useMemo(function () {
    var _options$modifiers = options.modifiers,
      modifiers = _options$modifiers === void 0 ? [] : _options$modifiers;
    return _objectSpread(_objectSpread({}, options), {}, {
      modifiers: [].concat(_toConsumableArray(modifiers), [{
        name: 'preventOverflow',
        options: {
          padding: 8
        }
      }])
    });
  }, [options]);
  useLayoutEffect(function () {
    var instance = createPopper(referenceRef.current, popperRef.current, combinedOptions);
    instanceRef.current = instance;
    return function () {
      instance.destroy();
    };
  }, [combinedOptions]);
  useLayoutEffect(function () {
    instanceRef.current.setOptions(combinedOptions);
    instanceRef.current.update();
  }, [combinedOptions]);
  return {
    reference: referenceRef,
    popper: popperRef,
    instance: instanceRef
  };
});